import moment from "moment-timezone";
import "moment/locale/ar-ly";
import "moment/locale/fr";
import "moment/locale/de";
import "moment/locale/tr";

/** The Intl locale for the site language (dates, times, numbers); Arabic keeps Western digits. */
const INTL_LOCALES = { AR: "ar-EG-u-nu-latn", EN: "en", FR: "fr", DE: "de", TR: "tr" };
/** moment's locale per site language (ar-ly is standard Arabic months with Western digits). */
const MOMENT_LOCALES = { AR: "ar-ly", EN: "en", FR: "fr", DE: "de", TR: "tr" };

export const intlLocale = (lang) => INTL_LOCALES[lang] || "en";

export const numberText = (value, lang) => new Intl.NumberFormat(intlLocale(lang)).format(Number(value) || 0);

/** A date with its time, short ("Thu, 5 Nov, 6:00 PM"): when a scheduled room starts. */
export const shortDateTime = (date, lang) => new Intl.DateTimeFormat(intlLocale(lang), {
    weekday: "short", day: "numeric", month: "short", hour: "numeric", minute: "2-digit",
}).format(date);

const compactFormats = {};
/**
 * The one short form for every count on the site: under 1000 the plain number, then the language's
 * compact words with one decimal and Western digits ("12.5K", "1.2M"; Arabic "12.5 ألف", "1.2 مليون").
 */
export function compactNumber(value, lang) {
    const number = Number(value) || 0;
    if (Math.abs(number) < 1000) return String(Math.round(number));
    const locale = intlLocale(lang);
    compactFormats[locale] = compactFormats[locale] || new Intl.NumberFormat(locale,
        { notation: "compact", maximumFractionDigits: 1, numberingSystem: "latn" });
    return compactFormats[locale].format(number);
}

/** The word for `count` from its plural forms ({ one, two, few, many, other }) in the site language. */
export const pluralWord = (forms, count, lang) => forms?.[new Intl.PluralRules(intlLocale(lang)).select(count)] || forms?.other || "";

/** Points relative times and the page's `lang` (Turkish capitals, hyphenation, screen readers) at the site language. */
export function applySiteLanguage(lang) {
    moment.locale(MOMENT_LOCALES[lang] || "en");
    document.documentElement.lang = (lang || "en").toLowerCase();
}
